import { Box, Typography, Divider } from "@mui/material";
import AmchurCard from "../../components/AmchurCard";

export interface ComprehensiveNoteProps {
  patientData?: {
    PatientName?: string | null;
    PatientMrNo?: string | null;
    PatientBioData?: string | null;
    PatientVitals?: string | null;
    PatientPrescriptions?: string | null;
    PatientAdmissions?: string | null;
    PatientLabs?: string | null;
    PatientRadiology?: string | null;
  } | null;
}

// Helper function to safely parse JSON fields
const parseJSON = (data: string | null) => {
  try {
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error parsing JSON data:", error);
    return null;
  }
};

const ComprehensiveNote = ({ patientData }: ComprehensiveNoteProps) => {
  if (!patientData) {
    return (
      <AmchurCard
        title={"Comprehensive Note"}
        role="primary"
        allowEdit={false}
        allowComparison={false}
      >
        <></>
      </AmchurCard>
    );
  }

  const {
    // PatientName,
    // PatientMrNo,
    // PatientBioData,
    PatientVitals,
    PatientPrescriptions,
    PatientAdmissions,
    PatientLabs,
    PatientRadiology,
  } = patientData;

  // const bioData = parseJSON(PatientBioData ?? null);
  const vitals = parseJSON(PatientVitals ?? null);
  const prescriptions = parseJSON(PatientPrescriptions ?? null);
  const admissions = parseJSON(PatientAdmissions ?? null);
  const labs = parseJSON(PatientLabs ?? null);
  const radiology = parseJSON(PatientRadiology ?? null);

  return (
    <AmchurCard
      title={"Comprehensive Note"}
      role="primary"
      allowEdit={false}
      allowComparison={false}
    >
      <Box sx={{ textAlign: "left", p: 2 }}>
        {/*  Patient Basic Info
        <Typography variant="h5" color="primary">
          Patient Information
        </Typography>
        <Typography variant="body1">
          <strong>Name:</strong> {PatientName || "N/A"}
        </Typography>
        <Typography variant="body1">
          <strong>MR No:</strong> {PatientMrNo || "N/A"}
        </Typography>
        <Divider sx={{ my: 2 }} />

        {bioData && (
          <>
            <Typography variant="h6" color="secondary">
              Bio Data
            </Typography>
            {Object.entries(bioData).map(([key, value]) => (
              <Typography key={key} variant="body2">
                <strong>{key}:</strong>{" "}
                {typeof value === "object" && value !== null
                  ? JSON.stringify(value, null, 2) // Convert object to formatted JSON string
                  : String(value)}
              </Typography>
            ))}
            <Divider sx={{ my: 2 }} />
          </>
        )}
        */}

        {vitals && (
          <>
            <Typography variant="h6" color="secondary">
              Vitals
            </Typography>
            {Object.entries(vitals)
              .sort(
                ([dateA], [dateB]) =>
                  new Date(dateB).getTime() - new Date(dateA).getTime()
              )
              .map(([key, value]) => (
                <Typography key={key} variant="body2">
                  <strong>{key}:</strong>{" "}
                  {typeof value === "object" && value !== null
                    ? JSON.stringify(value, null, 2) // Convert object to formatted JSON string
                    : String(value)}
                </Typography>
              ))}
            <Divider sx={{ my: 2 }} />
          </>
        )}

        {/* Prescriptions */}
        {prescriptions && (
          <>
            <Typography variant="h6" color="secondary">
              Prescriptions
            </Typography>
            {Object.entries(prescriptions)
              .sort(
                ([dateA], [dateB]) =>
                  new Date(dateB).getTime() - new Date(dateA).getTime()
              )
              .map(([key, value]) => (
                <Typography key={key} variant="body2">
                  <strong>{key}:</strong>{" "}
                  {typeof value === "object" && value !== null
                    ? JSON.stringify(value, null, 2) // Convert object to formatted JSON string
                    : String(value)}
                </Typography>
              ))}
            <Divider sx={{ my: 2 }} />
          </>
        )}

        {/* Admissions */}
        {admissions && (
          <>
            <Typography variant="h6" color="secondary">
              Admissions
            </Typography>
            {Object.entries(admissions)
              .sort(
                ([dateA], [dateB]) =>
                  new Date(dateB).getTime() - new Date(dateA).getTime()
              )
              .map(([key, value]) => (
                <Typography key={key} variant="body2">
                  <strong>{key}:</strong>{" "}
                  {typeof value === "object" && value !== null
                    ? JSON.stringify(value, null, 2) // Convert object to formatted JSON string
                    : String(value)}
                </Typography>
              ))}
            <Divider sx={{ my: 2 }} />
          </>
        )}

        {/* Labs */}
        {labs && (
          <>
            <Typography variant="h6" color="secondary">
              Lab Reports
            </Typography>
            {Object.entries(labs)
              .sort(
                ([dateA], [dateB]) =>
                  new Date(dateB).getTime() - new Date(dateA).getTime()
              )
              .map(([key, value]) => (
                <Typography key={key} variant="body2">
                  <strong>{key}:</strong>{" "}
                  {typeof value === "object" && value !== null
                    ? JSON.stringify(value, null, 2) // Convert object to formatted JSON string
                    : String(value)}
                </Typography>
              ))}
            <Divider sx={{ my: 2 }} />
          </>
        )}

        {/* Radiology */}
        {radiology && (
          <>
            <Typography variant="h6" color="secondary">
              Radiology Reports
            </Typography>
            {Object.entries(radiology)
              .sort(
                ([dateA], [dateB]) =>
                  new Date(dateB).getTime() - new Date(dateA).getTime()
              )
              .map(([key, value]) => (
                <Typography key={key} variant="body2">
                  <strong>{key}:</strong>{" "}
                  {typeof value === "object" && value !== null
                    ? JSON.stringify(value, null, 2) // Convert object to formatted JSON string
                    : String(value)}
                </Typography>
              ))}
          </>
        )}
      </Box>
    </AmchurCard>
  );
};

export default ComprehensiveNote;
